import {Button, Card, Form} from "react-bootstrap";
import React, {useState} from "react";
import {setAuthToken} from "../controller/dataFetch";
import { useForm } from "react-hook-form";
import {Navigate} from "react-router-dom";
import jwt from 'jwt-decode';
import axios from "axios";



function Login(){
    const { register, handleSubmit, reset } = useForm();
    const [error, setError] = useState('');
    const [login,setLogin] = useState(null);
    const [credentialExpired,setExpired] = useState(false);
    const [show2FA, setShow2FA] = useState(false);
    const [sessionKey, setSessionKey] = useState(null);

    function submit(e) {
        let bodyFormData = new FormData();
        bodyFormData.append("studentNumber", e.username);
        bodyFormData.append("password", e.password);

        axios.post("/auth/login", bodyFormData,{headers: {'content-type': 'application/x-www-form-urlencoded'}})
            .then(response => {


                const { accessToken, requiresPasswordMigration, requires2FA, migrationMessage, sessionKey: responseSessionKey } = response.data;
                
                // Handle password migration first
                if (requiresPasswordMigration) {
                    const token = accessToken;
                    let jwtdata = jwt(token);
                    localStorage.setItem("token", token);
                    localStorage.setItem("role", jwtdata.role);
                    localStorage.setItem("id", jwtdata.sub.split(":")[0]);
                    setLogin("migration");
                    setAuthToken(token);
                    return;
                }
                
                // Handle 2FA verification
                if (requires2FA === true) {
                    console.log("2FA required");
                    setSessionKey(responseSessionKey);
                    setShow2FA(true);
                    setError(''); // Clear any previous errors
                    reset({ username: e.username, password: '', twoFactorCode: '' }); // Clear password but keep username
                    return;
                }

                // Normal login completion
                const token = accessToken;
                let jwtdata = jwt(token);
                localStorage.setItem("token", token);
                localStorage.setItem("role", jwtdata.role);
                localStorage.setItem("id", jwtdata.sub.split(":")[0]);
                
                if(e.password === "alpine"){
                    setExpired(true);
                }
                if(jwtdata.role.includes("TEACHER", "ADMIN")){
                    setLogin("TEACHER");
                }else{
                    setLogin("STUDENT");
                }

                setAuthToken(token);
            })
            .catch(err => {
                console.log(err)
                if(err.response.status === 401){
                    setError("Username or password incorrect!");
                }else{
                    setError(err.response.data.message);
                }

            });

    }

    function submit2FA(e) {
        if (!sessionKey) {
            setError('Session expired. Please login again.');
            return;
        }

        let bodyFormData = new FormData();
        bodyFormData.append("sessionKey", sessionKey);
        bodyFormData.append("code", e.twoFactorCode);

        axios.post("/auth/login/2fa", bodyFormData, {
            headers: {
                'content-type': 'application/x-www-form-urlencoded'
            }
        })
        .then(response => {
            // Assuming the 2FA endpoint returns the same structure as regular login
            const { accessToken } = response.data;
            
            if (accessToken) {
                // Complete login with the token
                const token = accessToken;
                let jwtdata = jwt(token);
                localStorage.setItem("token", token);
                localStorage.setItem("role", jwtdata.role);
                localStorage.setItem("id", jwtdata.sub.split(":")[0]);
                
                if(jwtdata.role.includes("TEACHER", "ADMIN")){
                    setLogin("TEACHER");
                }else{
                    setLogin("STUDENT");
                }

                setAuthToken(token);
            } else {
                setError("Invalid 2FA code. Please try again.");
            }
        })
        .catch(err => {
            console.log(err);
            if (err.response?.status === 401) {
                setError("Invalid 2FA code or session expired. Please try again.");
            } else {
                setError("Invalid 2FA code. Please try again.");
            }
        });
    }

    function goBackToLogin() {
        setShow2FA(false);
        setSessionKey(null);
        setError('');
        reset();
    }

        return (
            <>

                {login === "TEACHER" ? <Navigate to="/" /> : ''}
                {login === "STUDENT" ? <Navigate to={"/student/"+localStorage.getItem("id")} /> : ''}
                {login === "migration" ? <Navigate to="/password-migration" /> : ''}
                {credentialExpired ? <Navigate to="/credentials" /> : ''}
                
                {!show2FA ? (
                    <>
                        <Card.Title>Sign-in</Card.Title>
                        <Form onSubmit={handleSubmit(submit)}>
                            <label style={{color: "red"}}>{error}</label>
                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                <Form.Label>Email or student number for legacy accounts</Form.Label>
                                <Form.Control {...register("username")} type="text" placeholder="Enter Studentnumber or Username" />
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="formBasicPassword">
                                <Form.Label>Password</Form.Label>
                                <Form.Control {...register("password")} type="password" placeholder="Password" />
                            </Form.Group>
                            <Button variant="primary" style={{width: '100%'}} type="submit">
                                Submit
                            </Button>
                        </Form>
                        <div className="text-center mt-3">
                            <Button 
                                variant="link" 
                                onClick={() => window.location.href = '/forgot-password'}
                            >
                                Forgot Password?
                            </Button>
                        </div>
                    </>
                ) : (
                    <>
                        <Card.Title>Two-Factor Authentication</Card.Title>
                        <p className="text-muted mb-3">
                            Please enter the 6-digit code from your authenticator app to complete your login.
                        </p>
                        <Form onSubmit={handleSubmit(submit2FA)}>
                            <label style={{color: "red"}}>{error}</label>
                            <Form.Group className="mb-3" controlId="form2FACode">
                                <Form.Label>Authentication Code</Form.Label>
                                <Form.Control 
                                    {...register("twoFactorCode", { 
                                        required: true,
                                        pattern: /^[0-9]{6}$/
                                    })} 
                                    type="text" 
                                    placeholder="000000"
                                    maxLength="6"
                                    className="text-center"
                                    style={{ fontSize: '1.2em', letterSpacing: '0.2em' }}
                                />
                                <Form.Text className="text-muted">
                                    Enter the 6-digit code from your authenticator app
                                </Form.Text>
                            </Form.Group>
                            <div className="d-grid gap-2">
                                <Button variant="primary" type="submit">
                                    Verify Code
                                </Button>
                                <Button variant="outline-secondary" onClick={goBackToLogin}>
                                    Back to Login
                                </Button>
                            </div>
                        </Form>
                    </>
                )}

            </>
        )

}

export default Login;